import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { BackendService } from '../../core/backend.service';
import { DialogService } from '../../shared-components/modals/dialog.service';
import { MomentDateAdapter, MOMENT_DATE_FORMATS } from '../../shared-services/date-adapter';
import { NavigationService } from '../../shared-services/navigation.service';
import { SnackService } from '../../shared-services/snack.service';
import { ImagenBanner } from '../banner-imagen-upload/imagen-banner.model';
import { Banner } from '../banner.model';
import { ImagenBannerDto } from '../imagen-bannerDto.model';

@Component({
  selector: 'app-banner-carousel',
  templateUrl: './banner-carousel.component.html',
  styleUrls: ['./banner-carousel.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'es-Ar' },
    { provide: DateAdapter, useClass: MomentDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: MOMENT_DATE_FORMATS }
    ]
})
export class BannerCarouselComponent implements OnInit {
  private re = /(?:\.([^.]+))?$/;
  bannersActivos: ImagenBannerDto[] = [];
  nuevoBanner: ImagenBannerDto = new ImagenBannerDto(undefined);
  imagen: ImagenBanner = new ImagenBanner;
  validationFail = false;
  @ViewChild('form') public bannerForm: NgForm;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private navigationService: NavigationService,
    private snackService: SnackService,
    private backendService: BackendService,
    private dialogService: DialogService
  ) { }

  async ngOnInit() {
    await this.backendService.getImagenes(Banner.path + 'bannersActivos').then(a =>{
      this.bannersActivos = a;
    })
    if(this.bannersActivos.length == 0){this.agregarImagen()}
  }

  back() {
    this.navigationService.back();
  }

  async confirmSave() {
    if (this.validateAll()) {
      this.dialogService.confirm(this.bannersActivos ? 'Edición de banner' : 'Alta de banner',
      '¿Está seguro que desea guardar el banner?')
      .then( res => {
        if (res) {this.save(res);}
      });
    }
  }

  validateAll(){
    return this.validateForm() && this.validateImagenes() && this.validateDesktop() && this.validateCategorias();
  }

  validateForm() {
    let validationsOK = false;
    if ((this.bannersActivos.length>0) && (this.bannersActivos != undefined)) {
      validationsOK = true;
      this.validationFail = false;
    }
    return validationsOK;
  }
  
  validateImagenes(){
    for(var i = 0; i <this.bannersActivos.length; i++){
      if (this.bannersActivos[i].nombre == null || this.bannersActivos[i].nombre == undefined){
        this.snackService.error('Debe cargar una imágen al banner.');
        return false;
      }
    }
    return true;
  }

  validateDesktop(){
    for(var i = 0; i <this.bannersActivos.length; i++){
      if (this.bannersActivos[i].es_desktop == null || this.bannersActivos[i].es_desktop == undefined){
        this.snackService.error('Debe seleccionar un tipo de imagen al banner' + this.bannersActivos[i].nombre + '.');
        return false;
      }
    }
    return true;
  }

  validateCategorias(){
    for(var i = 0; i <this.bannersActivos.length; i++){
      if (this.bannersActivos[i].categoriaProducto.description == 'NUEVA CATEGORÍA' || this.bannersActivos[i].categoriaProducto == undefined || this.bannersActivos[i].categoriaProducto == null){
        this.snackService.error('Debe seleccionar una categoría para el banner' + this.bannersActivos[i].nombre + '.');
        return false;
      }
    }
    return true;
  }

  async save(res) {
    if (res) {
      this.snackService.spinner(true);
      var desktopCounter = 0;
      var mobileCounter = 0;
      for(let i = 0; i<this.bannersActivos.length; i++){
        this.nuevoBanner = this.bannersActivos[i];
        console.log(this.nuevoBanner)
        console.log(this.bannersActivos[i])
        if(this.nuevoBanner.es_desktop == "Desktop"){
          this.nuevoBanner.nombre = "CarouselDesktop" + desktopCounter + ".jpg";
          desktopCounter = desktopCounter + 1;
        }else{
          this.nuevoBanner.nombre = "CarouselMobile" + mobileCounter + ".jpg";
          mobileCounter = mobileCounter + 1;
        }
      if (this.nuevoBanner.id == null || this.nuevoBanner.id == undefined || this.nuevoBanner.id == 0) {
        try {
          const response = await this.backendService.createWithResponse(Banner.path, this.nuevoBanner);
          const clienteResponse = JSON.parse(await (response as Response).text());
          this.saveImagenes(clienteResponse.id);
        } catch (ex) {
          if (ex[0]) {
            this.snackService.error(ex[0].details);
          } else if (ex.errors) {
            this.snackService.error(ex.errors[0].defaultMessage);
          } else {
            this.snackService.error(ex.message);
          }
        } finally {
          this.snackService.spinner(false);
        }
      }else{
        try {
          this.saveImagenesExistentes(this.nuevoBanner);
        } catch (ex) {
          if (ex[0]) {
            this.snackService.error(ex[0].details);
          } else if (ex.errors) {
            this.snackService.error(ex.errors[0].defaultMessage);
          } else {
            this.snackService.error(ex.message);
          }
        } finally {
          this.snackService.spinner(false);
        }
      }
    }
    }
  }

  saveImagenes(bannerId) {
    try {
      let formdata: FormData;
      const archivo = this.nuevoBanner;
      //if (archivo.id !== undefined && archivo.file !== null && archivo.file !== undefined) {
        formdata = new FormData();
        formdata.append('file', archivo.file);
        formdata.append('nombre', archivo.nombre);
        formdata.append('id', bannerId);
        formdata.append('es_desktop', archivo.es_desktop);
        formdata.append('description', archivo.categoriaProducto.description);
        this.backendService.createFile(Banner.path + 'subirImagenesCarousel', formdata);
        this.snackService.success('Banner editado satisfactoriamente');
      //}
    } catch (ex) {
      this.snackService.error(ex.message);
    }
  }

  saveImagenesExistentes(bannerActivo:ImagenBannerDto) {
    try{
      this.backendService.update(Banner.path + "updateBanner", bannerActivo);
      this.snackService.success('Banner' + bannerActivo.nombre + 'editado satisfactoriamente');
    }catch(ex){
      this.snackService.error(ex.message)
    }
  }

  agregarImagen(){
    this.bannersActivos.push(new ImagenBannerDto(undefined))
  }

  delay(ms: number) {
    return new Promise( resolve => setTimeout(resolve, ms) );
  }

}



// WEBPACK FOOTER //
// ./src/app/banner/banner-carousel/banner-carousel.component.ts